import React from "react";

import { Link } from "react-router-dom";
function ServiceArea() {
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <section className="service-area sec-pad">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-lg-4 col-xl-4">
              <div className="title">
                <span>what we do</span>
                <h2>Transforming Ideas into Scalable Solutions</h2>
                <div className="cmn-btn">
                  <Link
                    onClick={scrollTop}
                    to={`${process.env.PUBLIC_URL}/service`}
                  >
                    view all services
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-8 col-xl-8">
              <div className="row g-4">
                <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <div className="single-service">
                    <span className="count">01</span>
                    <div className="service-icon">
                      <i>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/icons/service-icon-1.png"
                          }
                          alt="images"
                        />
                      </i>
                    </div>
                   <div className="service-content">
                    <h4>Custom Web Solutions</h4>
                    <p>
                      We design and develop fast, scalable, and user-focused websites that 
                      not only look great but also drive engagement and conversions.
                    </p>
                    <Link onClick={scrollTop} to={`${process.env.PUBLIC_URL}/service/web-development`}>
                      read more
                      <i>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/icons/arrow-circle.png"
                          }
                          alt="images"
                        />
                      </i>
                    </Link>
                  </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <div className="single-service">
                    <span className="count">02</span>
                    <div className="service-icon">
                      <i>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/icons/service-icon-2.png"
                          }
                          alt="images"
                        />
                      </i>
                    </div>
                    <div className="service-content">
                      <h4>Mobile App Development</h4>
                      <p>
                        We build intuitive, high-performance mobile applications that deliver seamless 
                        user experiences and scale with your business needs.
                      </p>
                      <Link onClick={scrollTop} to={`${process.env.PUBLIC_URL}/service/app-development`}>
                        read more
                        <i>
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/images/icons/arrow-circle.png"
                            }
                            alt="images"
                          />
                        </i>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <div className="single-service">
                    <span className="count">03</span>
                    <div className="service-icon">
                      <i>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/icons/service-icon-3.png"
                          }
                          alt="images"
                        />
                      </i>
                    </div>
                    <div className="service-content">
                      <h4>Game Development</h4>
                      <p>
                        We create engaging, high-performance games with immersive experiences, 
                        optimized gameplay, and scalable architecture for mobile, web, and desktop.
                      </p>
                      <Link onClick={scrollTop} to={`${process.env.PUBLIC_URL}/service/game-development`}>
                        read more
                        <i>
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/images/icons/arrow-circle.png"
                            }
                            alt="images"
                          />
                        </i>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <div className="single-service">
                    <span className="count">04</span>
                    <div className="service-icon">
                      <i>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/icons/service-icon-4.png"
                          }
                          alt="images"
                        />
                      </i>
                    </div>
                    <div className="service-content">
                      <h4>AI & Blockchain Solutions</h4>
                      <p>
                        We leverage AI, blockchain, and emerging technologies to build intelligent, 
                        secure, and future-ready solutions that drive innovation and business growth.
                      </p>
                      <Link onClick={scrollTop} to={`${process.env.PUBLIC_URL}/service/ai-development`}>
                        read more
                        <i>
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/images/icons/arrow-circle.png"
                            }
                            alt="images"
                          />
                        </i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ServiceArea;
